import type { PayloadAction } from '@reduxjs/toolkit';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getApiClient } from 'api';
import { getClubsById, type GetClubsByIdResponse } from 'api/generated';
import type { FollowUnfollowParameters } from 'store/followUnfollow/followUnfollowSlice';
import { setFollowed, setUnfollowed } from 'store/followUnfollow/followUnfollowSlice';

const FOLLOWABLE_TYPE = 'club';

export const fetchClubProfile = createAsyncThunk<GetClubsByIdResponse | null, number | string | undefined>(
  'clubs/fetchClubProfile',
  async (clubId, { rejectWithValue }) => {
    try {
      if (!clubId) return null;

      const response = await getClubsById({
        client: getApiClient(true),
        path: { id: Number(clubId) },
        throwOnError: true,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const clubProfileSlice = createSlice({
  name: 'userProfile',
  initialState: {
    error: false,
    loading: false,
    club: null as GetClubsByIdResponse | null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchClubProfile.pending, (state) => {
      state.loading = true;
      state.error = false;
    });
    builder.addCase(fetchClubProfile.fulfilled, (state, action: PayloadAction<GetClubsByIdResponse | null>) => {
      state.loading = false;
      state.club = action.payload;
    });
    builder.addCase(fetchClubProfile.rejected, (state) => {
      state.loading = false;
      state.error = true;
    });
    builder.addCase(setFollowed, (state, action: PayloadAction<FollowUnfollowParameters>) => {
      const { id, type } = action.payload;
      if (type === FOLLOWABLE_TYPE && state.club && state.club.id === id) {
        state.club.followed = true;
      }
    });
    builder.addCase(setUnfollowed, (state, action: PayloadAction<FollowUnfollowParameters>) => {
      const { id, type } = action.payload;
      if (type === FOLLOWABLE_TYPE && state.club && state.club.id === id) {
        state.club.followed = false;
      }
    });
  },
});

export const clubProfileReducer = clubProfileSlice.reducer;
